export default __webpack_public_path__ + "static/media/Ruth_9781408340523.16a6dbd0.jpg";